import type { OrderResult } from '../services/orderExecution';

interface OrderStatusProps {
  result: OrderResult | null;
  onDismiss: () => void;
}

export function OrderStatus({ result, onDismiss }: OrderStatusProps) {
  if (!result) return null;

  return (
    <div className="fixed bottom-4 right-4 max-w-md z-50 animate-slide-up">
      <div
        className={`rounded-lg p-4 shadow-lg ${
          result.success
            ? 'bg-green-900/90 border border-green-600'
            : 'bg-red-900/90 border border-red-600'
        }`}
      >
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h3 className={`font-semibold ${result.success ? 'text-green-100' : 'text-red-100'}`}>
              {result.success ? '✓ Order Placed' : '✗ Order Failed'}
            </h3>
            {result.success ? (
              <div className="mt-2 text-sm text-gray-200 space-y-1">
                {result.orderId && (
                  <div>
                    Order ID: <span className="font-mono">{result.orderId}</span>
                  </div>
                )}
                {result.filledSize && result.avgPrice ? (
                  <div>
                    Filled: <span className="font-mono">{result.filledSize}</span> @{' '}
                    <span className="font-mono">${result.avgPrice}</span>
                  </div>
                ) : (
                  <div className="text-gray-300">Order resting in orderbook</div>
                )}
              </div>
            ) : (
              <div className="mt-2 text-sm text-red-200">{result.error}</div>
            )}
          </div>
          <button
            onClick={onDismiss}
            className="ml-4 text-gray-300 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
